// extracted by mini-css-extract-plugin
module.exports = {"icon_adapt_responsive":"icon_adapt_responsive-4d0e46","big":"big-4d0e46","small":"small-4d0e46","white":"white-4d0e46"};